module.exports = __webpack_public_path__ + "static/media/air-quality-index-table.ccdddd35.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/help-and-guides/air-quality-index-table.png
// module id = 829
// module chunks = 0